import React, { forwardRef, useState } from "react";
import { connect, FieldArray, Form, Formik } from "formik";
import FormField from "components/FormField";
import _ from "lodash";


const EZField = connect((props) => {
  const values = _.cloneDeep(props.values);

  if (values.type === 'location' && props.field.key === 'vehicle_type') {
    props.field.options.push({ title: "Message", value: "msg" })
    props.field.options.push({ title: "Time", value: "time" })
  }

  if(props.field.key === 'merge_to_id'){
    const mergedUniqueIds = Array.from(new Set(
      props.formik.values.config.reduce((acc, obj) => {
        if (Array.isArray(obj.merge_to_id) && obj.merge_to_id.length > 0) {
          acc.push(obj.id);
          acc.push(...obj.merge_to_id.map(item => item.value));
        }
        return acc;
      }, [])
    ));

    const mergeToValues = props.formik.values.config
    .filter(obj => Array.isArray(obj.merge_to_id) && obj.merge_to_id.length > 0)
    .flatMap(obj => obj.merge_to_id.map(item => item.value));

    const shouldDisableAll = mergeToValues.includes(values.id);

    const updatedLedPanelList = props.ledPanelList
      .filter(item => item.value !== values.id)
      .map(item => ({
        ...item,
        disabled: shouldDisableAll || mergedUniqueIds.includes(item.value),
      }));

    props.field.options = updatedLedPanelList;
  }

  return(
    <div
      className={props.field.key === 'merge_to_id' ? 'col-md-4 col-12 w-100' : 'col-md-2 col-12 w-100' }
      key={`field-${props.field.key}`}
    >
      <FormField
        field={{
          ...props.field
        }}
      />
    </div>
  )
});

const LedRows = connect((props) => {
  const values = _.cloneDeep(props.values);

  return(
    <FieldArray
      name={props.config.key}
      render={({ arrayHelpers, remove, push}) => (
        <>
          {values[props.config.key].map((item, index) => (
            <div className="row">
              {props.config.fields.map((field, i) => {
                if(['merge_to_id'].includes(field.key) || (!(item[field.key] === null || item[field.key] === '') && !(field.key == 'rgb' && !props.rgbConfig) &&
                  (!Array.isArray(item[field.key]) || item[field.key].length > 0))){
                  return (
                    <EZField
                      field={{
                        ...field,
                        ...{
                          name: `${props.config.key}[${index}].${field.key}`,
                        }
                      }}
                      values={item}
                      ledPanelList ={props.ledPanelList}
                    />
                  )
                } else{
                  return null;
                }
              })}
            </div>
          ))}
        </>
      )}
    />
  );
});

const MergeLedRows = forwardRef(({config, rgbConfig, data, ledPanelList, handleRowMergeSubmit}, ref) => {
  const [initialValues, setInitialValues] = useState(data);
    
  return(
    <Formik
      onSubmit={handleRowMergeSubmit}
      initialValues={initialValues}
      innerRef={ref}
    >
      <Form>
        <LedRows
          config={config}
          rgbConfig={rgbConfig}
          values={data}
          ledPanelList={ledPanelList}
        />
      </Form>
    </Formik>
  )
});

export default MergeLedRows;